module.exports = __webpack_public_path__ + "img/member1.23d15938.png";